import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";
export const processingWashingApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        addProcessingMorningEmployee: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/processing-data/washing/add-ms-emp-data`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['morningEmployee', 'employee', 'summaryProcessing'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Employee")

            },

        }),
        addProcessingEveningEmployee: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/processing-data/washing/add-es-emp-data`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['eveningEmployee', 'employee', 'summaryProcessing'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Employee")

            },

        }),
        updateProcessingMorningEmployee: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `processing-data/washing/update-ms-emp-data/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['morningEmployee', 'employee', 'summaryProcessing'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        updateProcessingEveningEmployee: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/processing-data/washing/update-es-emp-data/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['eveningEmployee', 'employee', 'summaryProcessing'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data")
            },
        }),
        getProcessingMorningEmployee: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/processing-data/washing/ms-emp-logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['morningEmployee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getProcessingEveningEmployee: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/processing-data/washing/es-emp-logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['eveningEmployee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getProcessingWashingSummary: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/processing-data/washing/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['eveningEmployee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

    }),
});

export const {
    useAddProcessingEveningEmployeeMutation,
    useAddProcessingMorningEmployeeMutation,
    useGetProcessingEveningEmployeeQuery,
    useGetProcessingMorningEmployeeQuery,
    useGetProcessingWashingSummaryQuery,
    useUpdateProcessingEveningEmployeeMutation,
    useUpdateProcessingMorningEmployeeMutation,
} = processingWashingApi;